import { Rule } from 'rc-field-form/lib/interface';
const REQUIRED_RULES: Rule[] = [{
  required: true,
  whitespace: true,
  message: 'This field is required',
}];

export default REQUIRED_RULES;
